import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  addOrbitSessionData,
  updateOrbitSessionData,
  getOrbitProfileData,
  getOrbitAuditBySessionIdData,
  setIsOrbitLoading,
  saveOrbitProfileData,
  getOrbitDashboardData,
  setProfData,
  setPayData,
  setCompDocData,
  setAccredationsData,
  setAvbData,
  setIsStart,
  setIsStopTimer,
  setOrbitProfileData,
  addOrbitAuditData,
  setIsOrbitSessionMinutes,
  setIsOrbitSessionSeconds,
  setTimer,
  setOrbitAnimation,
  setIsAnimationPlaying,
  setOpenSuccessDialog,
  setTotalCount,
  setTotalPrice,
  setIsActive,
  getOrbitMonthlyReportData,
  getOrbitEarningsData,
  getOrbitUserSessionsData,
  getOrbitParkedServicesData,
  getOrbitActiveServicesData,
  changeOrbitServiceStatusData,
  getOrbitFollowUpServicesData,
  getOrbitPotentialEarningsData,
  getOrbitOtherDetailsData,
  setIsMonthlyReportLoadingData,
  setIsOrbitEarningLoadingData,
  setIsUserSessionLoadingData,
  setIsPotentialEarningLoadingData,
  setIsFollowupLoadingData,
  setIsOtherDetailsLoadingData,
  setIsActiveServicesLoadingData,
  setshowTestModeDialogData,
  setShowPharmacyNmsRequestDialogData,
  setShowCancelPharmacyNmsRequestDialogData,
  setisTestModeData,
  addTestModeServiceData,
  getPaymentDetailsData,
  getOrbitTeamByCompanyIdData,
  getOrbitAgencyUsersData,
  getOrbitAgencyDetailsData,
  getOrbitAgencyTimeAndCompletedData,
  getAgencyPharmaciesData,
  getAgencyOtherPharmaciesData,
  setSidebarVisibleData,
  getOrbitAgencyMonthlyReportData,
  getOrbitServicesWorkPlannerData,
  getOrbitPharmanautsWorkPlannerData,
  getOrbitWorkPlannerData,
  setSelectedRow,
  getOrbitAgnecyUserByEmailData,
  getOrbitAgencyServicesByCompanyIdData,
  toggleService,
  getOthersAvailableData,
  addExclusivePharmacyData,
  SaveOrbitPharmanautServicesData,
  getReportByIdData,
  getReportsData,
  setReportStartDateData,
  setReportEndDateData,
  setCurrentReportIdData,
  setSelectedMonthData,
  getUserCompletedNmsData,
  getPatientTimeLineData,
  approvePharmacyNmsRequestData,
  cancelPharmacyNmsRequestData,
  setSelectedPharmacyNmsRequestData,
  updateUserExclusiveStatus,
  getOrbitLiveNmsData,
  setCurrentNoteData,
} from "../features/orbitSlice/orbitSlice";

const reducerName = "template";

// #region State Setters
export const setCurrentOrbitLoading = (privateCount) => {
  dispatch(setIsOrbitLoading(privateCount));
};
export const setCurrentOrbitProfile = (data) => {
  dispatch(setOrbitProfileData(data));
};
export const setCurrentProfData = (data) => {
  dispatch(setProfData(data));
};
export const setCurrentPayData = (data) => {
  dispatch(setPayData(data));
};
export const setCurrentCompDocData = (data) => {
  dispatch(setCompDocData(data));
};
export const setCurrentAccredationsData = (data) => {
  dispatch(setAccredationsData(data));
};
export const setCurrentAvbData = (data) => {
  dispatch(setAvbData(data));
};
export const setIsMonthlyReportLoading = (data) => {
  dispatch(setIsMonthlyReportLoadingData(data));
};
export const setIsOrbitEarningLoading = (data) => {
  dispatch(setIsOrbitEarningLoadingData(data));
};
export const setIsUserSessionLoading = (data) => {
  dispatch(setIsUserSessionLoadingData(data));
};
export const setIsPotentialEarningLoading = (data) => {
  dispatch(setIsPotentialEarningLoadingData(data));
};
export const setIsFollowupLoading = (data) => {
  dispatch(setIsFollowupLoadingData(data));
};
export const setIsOtherDetailsLoading = (data) => {
  dispatch(setIsOtherDetailsLoadingData(data));
};
export const setIsActiveServicesLoading = (data) => {
  dispatch(setIsActiveServicesLoadingData(data));
};
export const setCurrentStart = (isStart) => {
  dispatch(setIsStart(isStart));
};
export const setCurrentStopTimer = (isStopTimer) => {
  dispatch(setIsStopTimer(isStopTimer));
};
export const setCurrentOrbitSessionMinutes = (minutes) => {
  dispatch(setIsOrbitSessionMinutes(minutes));
};
export const setCurrentOrbitSessionSeconds = (seconds) => {
  dispatch(setIsOrbitSessionSeconds(seconds));
};
export const setCurrentTimer = (timerValue) => {
  dispatch(setTimer(timerValue + 1));
};
export const setCurrentTimeActive = (isActive) => {
  dispatch(setIsActive(isActive));
};
export const setCurrentOrbitAnimation = (isOrbitAnimation) => {
  dispatch(setOrbitAnimation(isOrbitAnimation));
};
export const setCurrentAnimationPlaying = (isAnimationPlaying) => {
  dispatch(setIsAnimationPlaying(isAnimationPlaying));
};
export const setCurrentOpenSuccessDialog = (isOpen) => {
  dispatch(setOpenSuccessDialog(isOpen));
};
export const setCurrentTotalCount = (totalCount) => {
  dispatch(setTotalCount(totalCount));
};
export const setCurrentTotalPrice = (totalPrice) => {
  dispatch(setTotalPrice(totalPrice));
};
export const setshowTestModeDialog = (show) => {
  dispatch(setshowTestModeDialogData(show));
};
export const setShowPharmacyNmsRequestDialog = (show) => {
  dispatch(setShowPharmacyNmsRequestDialogData(show));
};
export const setShowCancelPharmacyNmsRequestDialog = (show) => {
  dispatch(setShowCancelPharmacyNmsRequestDialogData(show));
};
export const setSelectedPharmacyNmsRequest = (pharmacy) => {
  dispatch(setSelectedPharmacyNmsRequestData(pharmacy));
};
export const setIsTestMode = (testMode) => {
  dispatch(setisTestModeData(testMode));
};
export const setSidebarVisible = (isSidebar) => {
  dispatch(setSidebarVisibleData(isSidebar));
};
export const setSelectedRowData = (data) => {
  dispatch(setSelectedRow(data));
};
export const toggleUserService = (service) => {
  dispatch(toggleService(service));
};
export const setReportStartDate = (date) => {
  dispatch(setReportStartDateData(date));
};
export const setReportEndDate = (date) => {
  dispatch(setReportEndDateData(date));
};
export const setCurrentReportId = (reportId) => {
  dispatch(setCurrentReportIdData(reportId));
};
export const setSelectedMonth = (month) => {
  dispatch(setSelectedMonthData(month));
};

export const setCurrentNote = (note) => {
  dispatch(setCurrentNoteData(note));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const addOrbitSession = async (data) => {
  let result = null;

  try {
    result = await dispatch(addOrbitSessionData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const updateOrbitSession = async (data) => {
  let result = null;

  try {
    result = await dispatch(updateOrbitSessionData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const getOrbitProfile = async () => {
  let result = null;

  try {
    result = await dispatch(getOrbitProfileData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};
export const saveOrbitProfile = async (data) => {
  let result = null;
  try {
    result = await dispatch(saveOrbitProfileData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const addOrbitAudit = async (data) => {
  let result = null;

  try {
    result = await dispatch(addOrbitAuditData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }

  return result;
};

export const getOrbitAuditBySessionId = async (params) => {
  let result = null;

  try {
    result = await dispatch(getOrbitAuditBySessionIdData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};

export const getOrbitDashboard = async () => {
  let result = null;
  try {
    result = await dispatch(getOrbitDashboardData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};
export const getOrbitMonthlyReport = async (params) => {
  let result = null;
  try {
    result = await dispatch(getOrbitMonthlyReportData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const getOrbitEarnings = async (params) => {
  let result = null;
  try {
    result = await dispatch(getOrbitEarningsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const getOrbitUserSessions = async () => {
  let result = null;
  try {
    result = await dispatch(getOrbitUserSessionsData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};
export const getOrbitParkedServices = async (params) => {
  let result = null;
  try {
    result = await dispatch(getOrbitParkedServicesData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const getOrbitActiveServices = async (params) => {
  let result = null;
  try {
    result = await dispatch(getOrbitActiveServicesData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const changeOrbitServiceStatus = async (params) => {
  let result = null;
  try {
    result = await dispatch(changeOrbitServiceStatusData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const getOrbitFollowUpServices = async () => {
  let result = null;
  try {
    result = await dispatch(getOrbitFollowUpServicesData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};
export const getOrbitPotentialEarnings = async () => {
  let result = null;
  try {
    result = await dispatch(getOrbitPotentialEarningsData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};
export const getOrbitOtherDetails = async () => {
  let result = null;
  try {
    result = await dispatch(getOrbitOtherDetailsData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};

export const addTestModeService = async (params) => {
  let result = null;
  try {
    result = await dispatch(addTestModeServiceData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const getPaymentDetails = async () => {
  let result = null;

  try {
    result = await dispatch(getPaymentDetailsData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};

export const getOrbitTeamByCompanyId = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(getOrbitTeamByCompanyIdData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = null;
  }
  return result;
};

export const getOrbitAgencyUsers = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(getOrbitAgencyUsersData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = null;
  }
  return result;
};

export const getOrbitAgencyDetails = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(getOrbitAgencyDetailsData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = null;
  }
  return result;
};

export const getOrbitAgencyOtherDetails = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(
      getOrbitAgencyTimeAndCompletedData(companyId)
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = null;
  }
  return result;
};
export const getOrbitAgencyPharmacies = async (params) => {
  let result = null;
  try {
    result = await dispatch(getAgencyPharmaciesData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }

  return result;
};

export const getOrbitAgencyOtherPharmacies = async (params) => {
  let result = null;
  try {
    result = await dispatch(getAgencyOtherPharmaciesData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }

  return result;
};

export const getOrbitAgencyMonthlyReport = async (params) => {
  let result = null;
  try {
    result = await dispatch(getOrbitAgencyMonthlyReportData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }

  return result;
};

export const getOrbitServicesWorkPlanner = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(
      getOrbitServicesWorkPlannerData(companyId)
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = null;
  }
  return result;
};

export const getOrbitPharmanautsWorkPlanner = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(
      getOrbitPharmanautsWorkPlannerData(companyId)
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = null;
  }
  return result;
};

export const getOrbitWorkPlanner = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(getOrbitWorkPlannerData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = null;
  }
  return result;
};

export const getOrbitAgnecyUserByEmail = async (params) => {
  let result = null;
  try {
    result = await dispatch(getOrbitAgnecyUserByEmailData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};

export const getOrbitAgencyServicesByCompanyId = async (params) => {
  let result = null;
  try {
    result = await dispatch(
      getOrbitAgencyServicesByCompanyIdData(params)
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};

export const getOthersAvailable = async () => {
  let result = null;

  try {
    result = await dispatch(getOthersAvailableData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};

export const addExclusivePharmacy = async (params) => {
  let result = null;
  try {
    result = await dispatch(addExclusivePharmacyData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};

export const SaveOrbitPharmanautServices = async (data) => {
  let result = null;
  try {
    result = await dispatch(SaveOrbitPharmanautServicesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};
export const getUserCompletedNms = async (data) => {
  let result = null;
  try {
    result = await dispatch(getUserCompletedNmsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};
export const approvePharmacyNmsRequest = async (data) => {
  let result = null;
  try {
    result = await dispatch(approvePharmacyNmsRequestData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};
export const cancelPharmacyNmsRequest = async (data) => {
  let result = null;
  try {
    result = await dispatch(cancelPharmacyNmsRequestData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getOrbitPatientTimeline = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPatientTimeLineData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const getReports = async () => {
  let result = [];
  try {
    result = await dispatch(getReportsData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const getReportById = async (params) => {
  let result = [];
  try {
    result = await dispatch(getReportByIdData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = [];
  }
  return result;
};

export const updateUserExclusiveStatusDispatcher = async (params) => {
  let result = null;
  try {
    result = await dispatch(updateUserExclusiveStatus(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const getOrbitLiveNms = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getOrbitLiveNmsData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = [];
  }
  return result;
};

// #endregion
